
<app-page-header [breadcrumbs]="[
    {label: 'Shop',   url: root.shop()},
    {label: productDetails?.aliasName || '',  url: ''}
]"></app-page-header>
<div class="container product product--layout--{{ layout }}" *ngIf="productDetails">
    <div class="product__content">
        <div class="product__gallery">
            <app-product-gallery [productLayout]="layout" [images]="productDetails?.defaultImage"></app-product-gallery>
        </div>
        <div class="product__info">
            <h1 class="product__name">{{ productDetails?.aliasName }}</h1>
            <p class="paraAlign" align="left"><b>CODE</b><span
                    style="margin-left: 83px">{{productDetails?.productId}}</span></p>
            <p class="paraAlign" align="left"><b>AVAILABILITY</b>
                
                <span *ngIf="!productDetails?.isOutOfStock" style="margin-left: 38px">In Stock</span>
                <span *ngIf="productDetails?.isOutOfStock" style="margin-left: 38px;font-weight:bold;color:red;">Out Of
                    Stock</span>
            </p>
            <div>
                <p class="paraAlign" align="left"><b>PRODUCT TYPE</b><span
                        style="margin-left: 25px">{{productDetails?.subCategoryName}}</span></p>
            </div>
            <br>
            <p class="productFeatureFontStyle" [innerHTML]="productDetails?.features"></p>
        </div>
        <div class="product__sidebar" *ngIf="!productDetails?.isOutOfStock">
            <div class="product__availability">
                Availability: <span class="text-success">In Stock</span>
            </div>

            <div class="product__prices" *ngIf="productDetails">
                <ng-container *ngIf="productDetails.promotionCost">
                    <span class="product__new-price">{{ productDetails?.totalAmount | currencyFormat }}</span>{{ ' ' }}
                    <span class="product__old-price">{{ productDetails?.promotionCost|currencyFormat }}</span>
                </ng-container>
                <ng-container *ngIf="!productDetails.promotionCost">
                    {{ productDetails?.cost|currencyFormat }}
                </ng-container>
            </div>

            <form class="product__options">
                <div class="form-group product__option" style="margin-bottom: 50px;">
                    <label class="product__option-label">Quantity</label>
                    <div class="product__actions">
                        <div class="product__actions-item">
                            <app-input-number aria-label="Quantity" class="product__quantity" size="lg" [min]="1"
                                [formControl]="quantity"></app-input-number>
                        </div>
                        <div class="product__actions-item product__actions-item--addtocart">
                            <button type="button" class="btn btn-primary btn-lg"
                                [ngClass]="{'btn-loading': addingToCart}" appClick
                                (click)="addToCart(this.productDetails)">Add to cart</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>